import type React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function Icon3DCube16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="3D cube">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.55279 0.105573C7.83431 -0.0351909 8.16569 -0.0351909 8.44721 0.105573L14.4434 3.10369C14.4561 3.10997 14.4687 3.11654 14.4812 3.12339C14.5939 3.1852 14.6916 3.26703 14.771 3.36314C14.8237 3.42697 14.8683 3.4971 14.9037 3.57186C14.9563 3.6827 14.9886 3.8037 14.9975 3.9294C14.9992 3.95278 15 3.97633 15 4V11.4182C15 11.7525 14.8329 12.0648 14.5547 12.2502L8.55472 15.8321C8.47339 15.8863 8.38588 15.9275 8.29515 15.9555C8.11152 16.0122 7.91548 16.0147 7.73099 15.9632C7.64662 15.9396 7.56467 15.9048 7.48742 15.8586L1.48742 12.2768C1.18513 12.0964 1 11.7702 1 11.4182V4C1 3.81061 1.0535 3.62936 1.14935 3.47427C1.17924 3.42591 1.21324 3.38009 1.25103 3.33737C1.32621 3.25237 1.41635 3.1796 1.51879 3.12339C1.53129 3.11653 1.5439 3.10995 1.55661 3.10366L7.55279 0.105573ZM4.23607 4L8 5.88197L11.7639 4L8 2.11803L4.23607 4ZM3 5.61804V10.8505L7 13.2384V7.61804L3 5.61804ZM9.00002 7.61803V13.1315L13 10.883V5.61804L9.00002 7.61803Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function Icon3DCube24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="3D cube">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.49287 5.13813C2.79825 4.95844 3.17591 4.95377 3.48564 5.12584L12.4856 10.1258C12.8031 10.3022 13 10.6368 13 11V23C13 23.3594 12.8071 23.6912 12.4947 23.869C12.1824 24.0469 11.7986 24.0434 11.4895 23.8599L2.48952 18.517C2.18604 18.3369 2 18.0101 2 17.6571V6C2 5.64568 2.18749 5.31781 2.49287 5.13813ZM4 7.69951V17.0879L11 21.2434V11.5884L4 7.69951Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.5071 5.13813C21.2017 4.95844 20.8241 4.95377 20.5144 5.12584L11.5144 10.1258C11.1969 10.3022 11 10.6368 11 11V23C11 23.3594 11.1929 23.6912 11.5053 23.869C11.8176 24.0469 12.2014 24.0434 12.5105 23.8599L21.5105 18.517C21.814 18.3369 22 18.0101 22 17.6571V6C22 5.64568 21.8125 5.31781 21.5071 5.13813ZM20 7.69951V17.0879L13 21.2434V11.5884L20 7.69951Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.4856 0.125843C12.1836 -0.0419476 11.8164 -0.0419476 11.5144 0.125843L2.51436 5.12584C2.19689 5.30221 2 5.63683 2 6C2 6.36317 2.19689 6.69779 2.51436 6.87416L11.5144 11.8742C11.8164 12.0419 12.1836 12.0419 12.4856 11.8742L21.4856 6.87416C21.8031 6.69779 22 6.36317 22 6C22 5.63683 21.8031 5.30221 21.4856 5.12584L12.4856 0.125843ZM18.9409 6L12 9.85604L5.05913 6L12 2.14396L18.9409 6Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function Icon3DCube48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="3D cube">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.49104 11.1392C3.79538 10.9593 4.17212 10.9534 4.48192 11.1238L24.4819 22.1238C24.8015 22.2995 25 22.6353 25 23V47C25 47.3536 24.8133 47.6808 24.509 47.8608C24.2046 48.0407 23.8279 48.0466 23.5181 47.8762L3.51808 36.8762C3.19853 36.7005 3 36.3647 3 36V12C3 11.6464 3.1867 11.3192 3.49104 11.1392ZM5 13.6913V35.4087L23 45.3087V23.5913L5 13.6913Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M44.509 11.1392C44.2046 10.9593 43.8279 10.9534 43.5181 11.1238L23.5181 22.1238C23.1985 22.2995 23 22.6353 23 23V47C23 47.3536 23.1867 47.6808 23.491 47.8608C23.7954 48.0407 24.1721 48.0466 24.4819 47.8762L44.4819 36.8762C44.8015 36.7005 45 36.3647 45 36V12C45 11.6464 44.8133 11.3192 44.509 11.1392ZM43 13.6913V35.4087L25 45.3087V23.5913L43 13.6913Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.4819 0.123784C24.1818 -0.0412613 23.8182 -0.0412613 23.5181 0.123784L3.51808 11.1238C3.19853 11.2995 3 11.6353 3 12C3 12.3647 3.19853 12.7005 3.51808 12.8762L23.5181 23.8762C23.8182 24.0413 24.1818 24.0413 24.4819 23.8762L44.4819 12.8762C44.8015 12.7005 45 12.3647 45 12C45 11.6353 44.8015 11.2995 44.4819 11.1238L24.4819 0.123784ZM41.925 12L24 21.8587L6.07504 12L24 2.14127L41.925 12Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
